import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable, throwError } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { ExcelService } from './excel.service';
import { environment } from 'src/environments/environment';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
	providedIn: 'root'
})
export class BusinessService {

	constructor(
		private http: HttpClient,
		private excelService: ExcelService
	) { }


	//   getBusiness(mybuinessFilterList): Observable<any> {
	// 	var referral = JSON.parse(localStorage.getItem('userDetail'));
	// 		const params = {
	// 			'from': mybuinessFilterList.from,
	// 			'to': mybuinessFilterList.to,
	// 			'search': mybuinessFilterList.search,
	// 			'fromDate': mybuinessFilterList.fromDate,
	// 			'toDate': mybuinessFilterList.toDate,
	// 			'paymentStatusId': mybuinessFilterList.paymentStatusId,
	// 		}
	// 		return this.http.get(`${environment.endPoint}/ReferralBusiness/GetMyBusinessList?from=` + params.from + '&to=' + params.to + '&search=' + params.search + '&paymentStatusId=' + params.paymentStatusId + '&fromDate=' + params.fromDate + '&toDate=' + params.toDate)
	// 			.pipe(
	// 				map(res => res)
	// 			);
	// 	}

	getDashboard(mybuinessFilterList): Observable<any> {
		var referral = JSON.parse(localStorage.getItem('userDetail'));
		const params = {
			'userId': 1,
			'search': mybuinessFilterList.search || null,
			'from': mybuinessFilterList.from,
			'to': mybuinessFilterList.to,
			'fromDate': mybuinessFilterList.fromDate || null,
			'toDate': mybuinessFilterList.toDate || null,
			'paymentStatusIds': mybuinessFilterList.paymentStatusId,
		}
		return this.http.post(`${environment.endPoint}/ReferralBusiness/ReferralBusinessess/Count`, params);
	}


	fileExport(userBusinessDetails): Observable<any> {
		const params = {
		  'userId': 1,
		  'search': userBusinessDetails.search || null,
		  'from': userBusinessDetails.from,
		  'to': userBusinessDetails.to,
		  'fromDate': userBusinessDetails.fromDate || null,
		  'toDate': userBusinessDetails.toDate || null,
		  'paymentStatusIds': userBusinessDetails.paymentStatusIds,
		};
	  
		return this.http.post(`${environment.endPoint}/ReferralBusiness/Export`, params, { responseType: 'arraybuffer' })
		  .pipe(
			tap(data => {
			  this.excelService.saveAsExcelFile(data, 'ReferralMyBusiness');
			}),
			catchError(err => {
			  console.error("API Error:", err);
			  return throwError(() => err);
			})
		  );
	  }
	  
}
